import candidateApi from './api';

/**
 * Save a job to user's saved jobs
 * @param {Object} jobData - Complete job object to save
 * @returns {Promise} - API response
 */
export const saveJob = async (jobData) => {
    try {
        const response = await candidateApi.post('/save-job', jobData);
        return response.data;
    } catch (error) {
        console.error('Error saving job:', error);
        throw error;
    }
};

/**
 * Remove a saved job
 * @param {string|number} jobId - ID of job to remove
 * @returns {Promise} - API response
 */
export const removeSavedJob = async (jobId) => {
    try {
        const response = await candidateApi.delete(`/save-job/${jobId}`);
        return response.data;
    } catch (error) {
        console.error('Error removing saved job:', error);
        throw error;
    }
};

/**
 * Get all saved jobs for current user
 * @returns {Promise} - API response with saved jobs
 */
export const getSavedJobs = async () => {
    try {
        const response = await candidateApi.get('/save-job');
        return response.data;
    } catch (error) {
        console.error('Error fetching saved jobs:', error);
        throw error;
    }
};